import {PolicyLimitType} from '../PlanModel/enum/PolicyLimitType'
import {UsageType} from '../PlanModel/enum/UsageType'
import {IPlanFeature} from '../PlanModel/types/IPlanFeature'

const unlimited = -1

export function createDefaultWorkspaceUsageLimits(): Record<UsageType, number> {
  const u = UsageType
  return {
    [u.ProTokens]: unlimited,
    [u.LowTokens]: unlimited,
    [u.AutomationRuns]: unlimited,
    [u.Webhooks]: unlimited,
  }
}

export function createDefaultWorkspacePolicyLimits(): Record<PolicyLimitType, number> {
  const p = PolicyLimitType
  return {
    [p.ActivityLogRetentionDays]: unlimited,
    [p.MaxRecordsPerDatabase]: unlimited,
    [p.MaxDatabases]: unlimited,
    [p.StorageMegabytes]: unlimited,
    [p.MaxUsers]: unlimited,
    [p.MaxGuests]: unlimited,
    [p.SlaPercent]: 0,
  }
}

export function getDefaultWorkspaceEntitlements(): {
  planId: null
  currentPlanFeatures: IPlanFeature[]
  } {
  return {
    planId: null,
    currentPlanFeatures: [],
  }
}
